import { useQuery } from '@tanstack/react-query';
import { KnownAccessControls } from 'app/business-logic/security/KnownAccessControls';
import { getAlertConfigurations } from 'app/business-logic/services/alerts-services/getAlertConfigurations';
import { QUERY_KEY } from 'app/business-logic/services/query-key';
import { useHasAccess } from 'app/hooks/use-has-access';

export const useAlertConfigurations = () => {
  const hasAccess = useHasAccess()(KnownAccessControls.app.alerts._);
  const { data, isLoading, isFetching } = useQuery({
    queryKey: [QUERY_KEY.alertConfigurations],
    queryFn: () => getAlertConfigurations(),
    staleTime: Infinity,
    enabled: hasAccess,
  });
  return {
    data,
    isFetching,
    isLoading,
  };
};
